import type { IntegrationMilestone, IntegrationMilestoneState } from "../../../pages/hid-admin/dashboard/partner-organizations/partner-list/integration-status/integrationStatusTypes";

export const TIMELINE_PROGRESS_STATES: IntegrationMilestoneState[] = [
  "completed",
  "in-progress",
  "on-hold",
];

export const mapPhaseToMilestoneState = (
  status: string | null | undefined
): IntegrationMilestoneState => {
  const lower = (status || "").toLowerCase().trim();
  if (lower === "completed") return "completed";
  if (lower === "in progress" || lower === "inprogress") return "in-progress";
  if (lower === "on hold" || lower === "onhold") return "on-hold";
  return "pending";
};

export const NOT_APPLICABLE_META_LABEL = "Not Applicable";

export const isNotApplicableStatus = (status: string | null | undefined): boolean =>
  (status || "").toLowerCase().trim() === "not applicable";

export const getMilestoneMeta = (
  milestone: IntegrationMilestone,
  pendingLabel = "—"
): string => {
  if (milestone.state === "pending") {
    return milestone.statusLabel ?? pendingLabel;
  }

  return milestone.completedDate ?? milestone.statusDate ?? "—";
};

export const getTimelineProgressPercent = (
  milestones: IntegrationMilestone[]
): number => {
  const stepCount = milestones.length;
  if (stepCount === 0) return 0;

  const lastProgressIndex = milestones.reduce(
    (lastIndex, milestone, index) =>
      TIMELINE_PROGRESS_STATES.includes(milestone.state) ? index : lastIndex,
    -1
  );

  if (lastProgressIndex < 0) return 0;
  if (stepCount === 1) return 100;
  if (
    lastProgressIndex === stepCount - 1 &&
    milestones[lastProgressIndex].state === "completed"
  ) {
    return 100;
  }

  return (lastProgressIndex / (stepCount - 1)) * 100;
};
